import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Breadcrumbs,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { Permission } from '../../../utils/helpers/permissions';
import PermissionGate from '../../../utils/hooks/PermissionGate';
import { PreScreenBankSearch } from './PreScreenSearch';

export const PreScreenBank = () => {
  return (
    <Stack spacing={2}>
      <Paper
        variant='outlined'
        sx={{
          p: 1.5,
          borderRadius: 2,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          alignItems: { xs: 'flex-start', lg: 'center' },
          justifyContent: 'space-between',
          gap: 1.5,
          borderColor: 'divider',
        }}
      >
        <Breadcrumbs
          separator={<ChevronRight size={14} color='#94a3b8' />}
          aria-label='breadcrumb'
        >
          <Link
            component={RouterLink}
            to='#'
            underline='hover'
            color='text.secondary'
            fontSize='0.875rem'
          >
            Questions
          </Link>
          <Typography color='primary.main' fontWeight={600} fontSize='0.875rem'>
            Pre Screen Question Bank
          </Typography>
        </Breadcrumbs>

        <Stack direction='row' spacing={1} flexWrap='wrap'>
          <PermissionGate
            requiredPermissions={[Permission.QUESTIONS_VIEW]}
            matchAnyPermission={false}
          >
            <Link
              component={RouterLink}
              to='/question-bank'
              underline='none'
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'primary.main',
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              Question Bank
            </Link>
          </PermissionGate>
          <PermissionGate
            requiredPermissions={[Permission.JOB_VIEW]}
            matchAnyPermission={false}
          >
            <Link
              component={RouterLink}
              to='/content-manager'
              underline='none'
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'primary.main',
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              Content Manager
            </Link>
          </PermissionGate>
          <PermissionGate
            requiredPermissions={[Permission.JOB_CREATE]}
            matchAnyPermission={false}
          >
            <Link
              component={RouterLink}
              to='/upload-file'
              underline='none'
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'primary.main',
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              Auto Generate Questions
            </Link>
          </PermissionGate>
        </Stack>
      </Paper>

      <PreScreenBankSearch />
    </Stack>
  );
};
